import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/:customerId/deactivate`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const deactive = {
  post: apiPathFunc(pathBase),
};
